"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const native_1 = require("@react-navigation/native");
const images_1 = require("../../services/images");
const flight_1 = require("../../store/redux/flight");
const ProfilePictureWeb_1 = __importDefault(require("../common/flight_overview/ProfilePictureWeb"));
const UserRedirectorWeb = ({ receiverData, initiatorData }) => {
    const user = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const dispatch = (0, react_redux_1.useDispatch)();
    let receiver = receiverData;
    if (receiverData?.id === user?.id) {
        receiver = initiatorData;
    }
    const navigation = (0, native_1.useNavigation)();
    const navigateToReceiver = () => navigation.navigate("PassengerInfo");
    return ((0, jsx_runtime_1.jsxs)("div", { className: "receiver-bar", children: [(0, jsx_runtime_1.jsx)(ProfilePictureWeb_1.default, { imagePath: receiver?.image_path, className: "writer-image" }), (0, jsx_runtime_1.jsx)("div", { className: "receiver-name", children: (0, jsx_runtime_1.jsx)("p", { className: "font-14-400", children: receiver?.username }) }), (0, jsx_runtime_1.jsx)("div", { className: "bar-right-arrow", onClick: () => {
                    dispatch((0, flight_1.setPassenger)(receiver));
                    navigateToReceiver();
                }, children: (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.BarRightArrow, className: "bar-arrow-icon", alt: "arrow icon" }) })] }));
};
exports.default = UserRedirectorWeb;
